
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".2","clip-path":"url(#clip0_2122_1863)","fill":"#646E87"}},[_c('path',{attrs:{"d":"M18.25 3.99L14.8.404a1.279 1.279 0 00-1.86 0L9.49 3.99a1.404 1.404 0 000 1.933l3.45 3.586c.253.263.596.404.93.404.335 0 .678-.132.93-.404l3.45-3.586a1.404 1.404 0 000-1.933zM25.566 11.584h-2.439V9.087c0-.498-.19-.977-.533-1.324a1.795 1.795 0 00-1.273-.554h-2.375c-.37 0-.678.32-.678.704 0 .385.308.704.678.704h2.375c.117 0 .235.047.316.141a.487.487 0 01.136.329v2.497h-2.439c-.722 0-1.318.61-1.318 1.36v2.676c0 .751.587 1.37 1.318 1.37h6.222c.723 0 1.319-.61 1.319-1.37v-2.675c0-.751-.587-1.361-1.319-1.361h.01zM8.416 11.584H5.977V9.096c0-.122.046-.244.136-.338a.452.452 0 01.316-.14h2.375c.37 0 .677-.32.677-.705 0-.385-.307-.704-.677-.704H6.43c-.479 0-.94.197-1.273.554a1.982 1.982 0 00-.533 1.324v2.497h-2.43c-.722 0-1.318.61-1.318 1.36v2.676c0 .751.587 1.37 1.319 1.37h6.222c.722 0 1.318-.61 1.318-1.37v-2.675c0-.751-.587-1.361-1.318-1.361z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2122_1863"}},[_c('rect',{attrs:{"width":"26","height":"17","fill":"#fff","transform":"translate(.875)"}})])])])
          )
        }
      }
    